module.exports = __webpack_public_path__ + "media/preview/meetup@3x-e7e4d46d.png";